import { message, notification } from "antd"

export const useNotificationMessages = () => {
  const [api, contextHolder] = notification.useNotification()

  const successNotification = (label: string) => {
    api["success"]({
      className: "border-[0.5px] shadow-md rounded-lg",
      message: "Success",
      description: label,
    })
  }

  const errorNotification = (label: string) => {
    api["error"]({
      className: "border-[0.5px] shadow-md rounded-lg",
      message: "Error",
      description: label,
    })
  }
  const contextHolderNotification = contextHolder

  return { contextHolderNotification, successNotification, errorNotification }
}

export const useMessages = () => {
  const [messageApi, contextHolder] = message.useMessage()

  const successMessages = (label: string) => {
    messageApi.open({
      className: "border-[0.5px] shadow-sm rounded-lg",
      style: {
        marginTop: "2vh",
        width: "fit-content",
        margin: "auto",
      },

      type: "success",
      content: label,
    })
  }

  const errorMessages = (label: string) => {
    messageApi.open({
      className: "border-[0.5px] shadow-md rounded-lg",
      style: {
        marginTop: "2vh",
        width: "fit-content",
        margin: "auto",
      },
      type: "error",

      content: label,
    })
  }

  const contextHolderMessage = contextHolder

  return { contextHolderMessage, successMessages, errorMessages }
}
